import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useState } from "react";
import api from "../../../../../API";
import { useSelector } from "react-redux";

interface rejectProps {
  email: string;
  idx: number;
  setRejectPageOpen: React.Dispatch<React.SetStateAction<boolean>>
  // setOpen:React.Dispatch<React.SetStateAction<boolean>>;
  // getMemberList:any;
}

// const SampleRejectRsnDialog = () => {
const ContarctRejectRsnDialog = (props: any) => {

  const [reject_rsn , setReject_rsn] = useState("");

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // const documentReject = async () => {

  //   console.log(props.email)

  //   if(reject_rsn){
  //     console.log('사유 있음' , reject_rsn)
  //   }else{
  //     console.log('사유 없음' , reject_rsn)
  //   }
  //   // return;
  //   // var result = await api.post("/sampleConfirm",{"email":data.email,"role":selectedAuth,"new_file_name":data.new_file_name});

  //   // console.log('sampleConfirm result',result)
  //   await api.post("/documentReject",{"mgm_con_pk":props.email,"reject_rsn": reject_rsn,"email":email})
  //   .then((res:any) => {alert("반려 처리가 완료되었습니다. 사유: " + reject_rsn); props.setRejectPageOpen(false); props.getScriptFileList(); })
  //   .catch((e) => {if(e.response.status == 400) alert("반려처리 과정에 오류가 발생하였습니다.")})

  // }

  const f_scriptFileReject = async () => {

    // console.log('변경된 stt' , sttsrt)

    // console.log('기본 data' , data)

    // const base_data = sttsrt[0]

    const formData = new FormData();

    formData.append("email", email);
    formData.append("mgm_con_pk", props.mgm_con_pk);
    formData.append("idx", props.idx);
    formData.append("reject_rsn", reject_rsn);
    

    // formData.append("nvConScript", JSON.stringify(sttsrt));

    await api.post("/scriptFileReject",formData)
    .then((res:any) => {alert('스크립트 부적합이 완료되었습니다.'); props.scriptFileReject()})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  //   // alert("파일 업로드 실패. " + error.response.data.error);

    // await api.post("/sampleConfirm",{"worker":data.email,"role":"NKI","idx":data.idx,"type":"dialog","email":email})
    // .then((res:any) => {console.log('sampleConfirm result',res) , props.getScriptFileList(), props.setDialogOpen(false), alert("샘플 검수가 완료되었습니다. 권한: " + selectedAuth)})
    // .catch((e) => {if(e.response.status == 400) alert("서버오류입니다. ")})

  }
  

  return (
    <Box >
    <Dialog maxWidth="md" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}> 부적합사유 작성</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>

        <Box display="flex">
          <Box sx={{width:"100%", margin:"8px"}}>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>부적합사유</Box>
              <TextField
                value={reject_rsn}
                variant="standard"
                multiline
                fullWidth
                maxRows={4}
                sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setReject_rsn(event.target.value);
                }}
              />
              
            </Box>
          </Box>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.scriptFileReject();
          }}
        >
          취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            f_scriptFileReject();
          }}
        >
          부적합처리
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default ContarctRejectRsnDialog;
